// extracted by mini-css-extract-plugin
export default {"link":"WebStoreButton_link"};